module.exports = __webpack_public_path__ + "12a2f79bb9f8cf3a62721a3af3065e05.woff";


//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/fonts/Alegreya-BoldItalic.woff
// module id = 21
// module chunks = 0